import React, { useEffect } from "react";
import { Routes, Route, BrowserRouter, useLocation } from "react-router-dom";
import Home from "./page/Home";
import ScrollReveal from "scrollreveal";
import { ModalContextProvider } from "./context/ModalContext";
import { ThemeProvider } from "./context/ThemeProvider";
import { StyledEngineProvider } from '@mui/material/styles';

const ScrollToTop = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [location.pathname, location.search]);

  return children;
};

function App() {
  useEffect(() => {
    const sr = ScrollReveal({ origin: "top", distance: "60px", duration: 1300, delay: 100, });
    sr.reveal(".top-reveal", { delay: 60, origin: "top", interval: 100 });
    sr.reveal(".left-reveal", { delay: 60, origin: "left", interval: 100 });
    sr.reveal(".right-reveal", { delay: 60, origin: "right", interval: 100 });
    sr.reveal(".bottom-reveal", { delay: 60, origin: "bottom", interval: 100 });
    sr.reveal(".scaleUp", { scale: 0.85, });
  }, []);
  return (
    <BrowserRouter>
      <ThemeProvider>
        <StyledEngineProvider injectFirst>
          <ModalContextProvider>
            <ScrollToTop>
              <Routes>
                <Route path="/" element={<Home />} />
              </Routes>
            </ScrollToTop>
          </ModalContextProvider>
        </StyledEngineProvider>
      </ThemeProvider>
    </BrowserRouter >
  );
}

export default App;
